import React from 'react';
import './Achievements.css';

const Achievements = () => {
  const studentAchievements = [
    {
      name: "Priya Rajkumar",
      grade: "Grade XII - CBSE",
      score: "98.6%",
      achievements: [
        "State Topper in Mathematics",
        "JEE Main AIR 324",
        "National Merit Scholarship Recipient",
        "Admitted to IIT Madras - Computer Science"
      ],
      photoPlaceholder: "👩‍🎓"
    },
    {
      name: "Arjun Krishnan",
      grade: "Grade X - CBSE",
      score: "99.2%",
      achievements: [
        "School Topper with 99.2%",
        "Gold Medal in National Science Olympiad",
        "Perfect Score in Mathematics (100/100)",
        "Regional Champion in Quiz Competition"
      ],
      photoPlaceholder: "👨‍🎓"
    },
    {
      name: "Aishwarya Menon",
      grade: "Grade XI - IGCSE",
      score: "A* in 8/8",
      achievements: [
        "All A* grades in IGCSE",
        "Cambridge Outstanding Learner Award",
        "International Olympiad Silver Medalist",
        "Selected for NASA Space Camp"
      ],
      photoPlaceholder: "👩‍🎓"
    },
    {
      name: "Karthik Venkatesh",
      grade: "Grade XII - Matric",
      score: "587/600",
      achievements: [
        "District Rank 1 in Tamil Nadu Board",
        "NEET AIR 1245",
        "Selected for MBBS at Madras Medical College",
        "State Level Athletic Champion"
      ],
      photoPlaceholder: "👨‍🎓"
    },
    {
      name: "Divya Sharma",
      grade: "Grade IX - ICSE",
      score: "97.8%",
      achievements: [
        "Top 5 in ICSE Regional Examination",
        "National Talent Search Exam Qualifier",
        "Won State Level Debate Competition",
        "Published Young Author"
      ],
      photoPlaceholder: "👩‍🎓"
    },
    {
      name: "Rohan Kumar",
      grade: "Grade XII - IB",
      score: "44/45",
      achievements: [
        "IB Diploma with 44 points",
        "Extended Essay - Top Grade",
        "Admitted to MIT - Engineering",
        "International Robotics Competition Winner"
      ],
      photoPlaceholder: "👨‍🎓"
    }
  ];

  return (
    <section id="achievements" style={{ background: 'var(--light-grey)' }}>
      <div className="section-header">
        <h2 className="section-title">Star Performers</h2>
        <p className="section-subtitle">
          Celebrating our students' extraordinary achievements
        </p>
      </div>
      <div className="achievements-showcase">
        {studentAchievements.map((student, index) => (
          <div key={index} className="student-achievement-card">
            <div className="student-photo-container">
              <div className="image-placeholder student-photo">
                {student.photoPlaceholder}
              </div>
              <div className="achievement-badge">{student.score}</div>
            </div>
            <div className="student-info">
              <h3 className="student-name">{student.name}</h3>
              <p className="student-grade">{student.grade}</p>
              <ul className="achievement-details">
                {student.achievements.map((achievement, idx) => (
                  <li key={idx}>{achievement}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <p style={{ textAlign: 'center', marginTop: '3rem', opacity: 0.7, fontSize: '0.95rem' }}>
        * Replace emoji placeholders with actual student photos (with consent)
      </p>
    </section>
  );
};

export default Achievements;
